import type {CSSProperties} from 'react';
import {font, radius, space, weight} from '../scale.js';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeAchievementLook = 'achievement-share' | 'achievement-keep';

/* Released achievement card (the milestone overlay after a first brief, a streak, a saved step or a brief count): two full-width controls
   stacked in the card. Share is a 50px block with a 14px radius on the label fill with the page ink, 15px semibold type in the Wedge font,
   and a centered flex row with an 8px gap that holds the send glyph and the call to action. Keep going is a bare text button with no
   fill and no border, 14px padding and 14px medium type in the secondary ink and the Wedge font. Neither draws a transparent target
   (wedgeSettingsDrawsHit): both fill the card width, share is 50px high, and keep going takes 14px of padding round its line of type.
   Each reads the exact legacy roles, so the shipped ink rules keep matching. The caller owns the margin above Keep going and the
   children. */
const SHARE_HEIGHT = 50, KEEP_PAD = 14;

export function wedgeAchievementStyle(look: WedgeAchievementLook): CSSProperties {
  if (look === 'achievement-share') return {
    width: '100%', height: SHARE_HEIGHT, borderRadius: radius.xl, background: wedgeExactRole('label'), color: wedgeExactRole('bg'),
    border: 0, cursor: 'pointer', fontSize: font.callout, fontWeight: weight.semibold, fontFamily: wedgeExactRole('font'),
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: space[2],
  };
  return {
    width: '100%', background: 'none', border: 0, color: wedgeExactRole('labelSec'), fontSize: font.body, fontWeight: weight.medium,
    padding: KEEP_PAD, cursor: 'pointer', fontFamily: wedgeExactRole('font'),
  };
}
